import { styled } from 'styled-components'

export const StyledStepsContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: 9.75rem;
  height: 0.75rem;
  flex-direction: row;
  align-items: center;
  padding: 0.125rem;
  border-radius: 0.75rem;
  background-color: ${({ theme }) => theme.colors['N Surface/Primary']};
  box-shadow: 0 0 1rem 0 rgba(0, 0, 0, 0.06);
`

export const StyledProgress = styled.div.attrs<{ $progress: number }>(
  ({ $progress }) => ({
    style: {
      width: `max(${$progress > 0 ? '0.5rem' : '0px'}, ${$progress}%)`,
    },
  })
)`
  height: 100%;
  border-radius: 0.75rem;
  background-color: ${({ theme }) => theme.colors['N General/Brand']};
`
